<script setup lang="ts">
import type { TableColumn } from '@nuxt/ui'

import { computed, ref } from 'vue'

import AppDataTableShell from '@/components/common/AppDataTableShell.vue'

// Production-routable fixture for the data-table-shell e2e (see route-guard.vue for why it is
// not under src/pages/test/**). Mirrors the offer page, where `paginate` flips off together
// with the row count when a filter is applied.
definePage({
  meta: {
    requiresAuth: false,
  },
})

interface Row {
  id: number
  name: string
}

const allRows: Row[] = Array.from({ length: 30 }, (_, index) => ({
  id: index + 1,
  name: `Row ${index + 1}`,
}))
const columns: TableColumn<Row>[] = [{ accessorKey: 'name', header: 'Name' }]

const filtered = ref(false)
const rows = computed(() => (filtered.value ? allRows.slice(0, 3) : allRows))
const paginate = computed(() => rows.value.length > 10)
</script>

<template>
  <div>
    <button data-testid="toggle-filter" type="button" @click="filtered = !filtered">
      Toggle filter
    </button>
    <AppDataTableShell :data="rows" :columns="columns" :paginate="paginate" :page-size="10" />
  </div>
</template>
